import {Component, inject, Input, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Router, RouterLink} from '@angular/router';
import {UrlConstants} from '../../../core/constants/url.constants';
import {SessionDto} from '../../../core/models/session/sessiondto';
import {CommonService} from '../../../core/api/services/utility-services/common.service';
import {AccountInfo} from '../../../core/models/account/AccountInfo';
import {UserProfile} from '../../../core/models/user-profile/user-profile';
import {RoleConstants} from '../../../core/constants/role.constants';
import {CommunicationMaterial} from '../../../core/models/communicationMaterial/communication-material';
import {NgOptimizedImage, NgStyle} from '@angular/common';
import {AccountDto} from '../../../core/models/account/AccountDto';
import { FeedbackService } from '../../../core/api/services/feedback/feedback.service';

@Component({
    selector: 'app-left-column',
    standalone: true,
    imports: [
        TranslatePipe,
        RouterLink,
        NgOptimizedImage,
        NgStyle
    ],
    templateUrl: './left-column.component.html',
    styleUrl: './left-column.component.css'
})
export class LeftColumnComponent implements OnInit {

    session: SessionDto = new SessionDto();

    readonly UrlConstants = UrlConstants;
    readonly RoleConstants = RoleConstants;

    readonly commonService = inject(CommonService);
    readonly feedbackService = inject(FeedbackService);
    readonly router = inject(Router);


    accountInfo: AccountInfo;
    accountDto: AccountDto;
    userProfile: UserProfile;
    communicationMaterial: CommunicationMaterial;
    contactUsUrl: string;
    feedbackUrl: string;
    contactUsLabel: string;
    showYourOpionMatters: boolean;
    showCism: boolean;
    @Input() leftColumnWidth :string = '24%';
    @Input() userType :string = 'common';

    accessible = (role: string): boolean => this.session && this.session.userRoles?.includes(role);

    isOnPage = (page: string): boolean => this.router.url.includes(page);

    ngOnInit() {
      this.commonService.sessiondetails.subscribe(sessiondetails => {
        this.session = sessiondetails
      });
        this.commonService.getLeftColumnDtls(UrlConstants.homeUrl).subscribe(res => {
            this.accountInfo = res.accountInfo;
            this.accountDto = this.accountInfo?.accountDto;
            this.userProfile = res.userProfile;
            this.communicationMaterial = res.communicationMaterial;
            this.showYourOpionMatters = res.showYourOpinionMatters ? false : (this.accessible(RoleConstants.CUSTOMER) || (this.accessible(RoleConstants.PARTNER) && this.isOnPage(UrlConstants.homeUrl)));
            let csim = this.accessible(RoleConstants.CUSTOMER) ? (this.isOnPage(UrlConstants.homeUrl) ? true : this.isOnPage(`/${this.userType}/contactUs`)) : false;
            this.showCism = res.showCismBox && this.isOnPage(UrlConstants.contactUsCommonUrl) ? false : csim;
            this.contactUsUrl = this.accountInfo?.customer ? UrlConstants.contactUsCustomerUrl : (this.accountInfo.partner ? UrlConstants.contactUsPartnerUrl : UrlConstants.contactUsCommonUrl);
            this.feedbackUrl = this.accountInfo?.customer ? UrlConstants.customerFeedBackUrl : (this.accountInfo.partner ? UrlConstants.partnerFeedBackUrl : UrlConstants.clientFeedbackPartnerUrl);
            this.contactUsLabel = this.accountInfo?.customer ? "Contact Account Manager" : (this.accountInfo.partner ? "Contact Account Team" : "Contact Account Manager");
        })
    }

  onFeedbackLinkClick(): void {
    this.feedbackService.setSubmittedState(false);
  }


}
